import { currencyToNumber } from 'utils';

const GIFT_STATUS_MAP = {
  HIDDEN: 'DRAFT',
  PUBLIC: 'PUBLISHED',
};

const EXPIRY_USAGE_DAYS = {
  '7d': 7,
  '30d': 30,
  '90d': 90,
  '180d': 180,
  '1y': 365,
};

const slugify = (value) => value
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/đ/g, 'd')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

const toISOString = (value) => {
  if (!value) return undefined;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};

const computeExpiryAt = (expiryUsage) => {
  const days = EXPIRY_USAGE_DAYS[expiryUsage];
  if (!days) return undefined;
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString();
};

const getCategory = (giftType) => {
  if (giftType === 'VOUCHER') return 'VOUCHER';
  return 'EXCLUSIVE';
};

export default function buildGiftCreatePayload(values) {
  const {
    name,
    giftType,
    deliveryMethod,
    limitStartAt,
    limitEndAt,
    status,
    images = [],
    redeemPoints,
    stockQuantity,
    expiryUsage,
    shortDescription,
    howToUse,
    termsOfUse,
    returnPolicy,
    isLimited,
    voucherCampaign,
    perAccountRedeemLimit,
  } = values;

  const payload = {
    name: name.trim(),
    slug: slugify(name.trim()),
    description: shortDescription || '',
    images: images.map((item) => item.image).filter(Boolean),
    category: getCategory(giftType),
    isFlashSale: Boolean(isLimited),
    status: GIFT_STATUS_MAP[status] || 'DRAFT',
    deliveryMethod: deliveryMethod || 'BOOKESE_SYSTEM',
    coin: currencyToNumber(String(redeemPoints || '')) || 0,
    maxQuantityPerUser: Number(perAccountRedeemLimit) || 0,
    instructionForUse: howToUse || '',
    conditionApply: termsOfUse || '',
    returnPolicy: returnPolicy || '',
  };

  if (giftType !== 'VOUCHER') {
    payload.quantity = Number(stockQuantity) || 0;
  }

  if (giftType === 'VOUCHER' && voucherCampaign) {
    payload.voucherCampaign = voucherCampaign;
  }

  const startAt = toISOString(limitStartAt);
  const endAt = toISOString(limitEndAt);

  if (isLimited && startAt) {
    payload.startAt = startAt;
  }
  if (isLimited && endAt) {
    payload.endAt = endAt;
  }

  const expiryAt = computeExpiryAt(expiryUsage);
  if (expiryAt) {
    payload.expiryAt = expiryAt;
  }

  return payload;
}
